module.exports = __webpack_public_path__ + "static/job-finding-app-plp-d067d24e4e118e307d505dd2d986f908.png";